import { DriverVacation } from "@/interfaces";
import api from "@/lib/axios";
import { DefaultGetRequestParams, DefaultResponse } from "./types";

interface DriverVacationInput {
  driver_id: number;
  start_date: string;
  end_date: string;
}

export const driverVacationService = {
  async index({
    page,
    per_page,
    search,
    filters = {},
  }: DefaultGetRequestParams) {
    const response = await api.get<DefaultResponse<DriverVacation>>(
      "/driver_vacation",
      {
        params: {
          page: page,
          per_page: per_page,
          search: search,
          ...filters,
        },
      },
    );
    return response.data;
  },

  async destroy(id: number) {
    const response = await api.delete(`/driver_vacation/${id}`);
    return response.data;
  },

  async show(id: number) {
    const response = await api.get<DefaultResponse<DriverVacation, false>>(
      `/driver_vacation/${id}`,
    );
    return response.data;
  },

  async update(id: number | string, data: DriverVacationInput) {
    const response = await api.put(`/driver_vacation/${id}`, data);
    return response.data;
  },

  async create(data: DriverVacationInput) {
    const response = await api.post("/driver_vacation", data);
    return response.data;
  },

  async getByDriverId(driverId: number) {
    const response = await api.get<DefaultResponse<DriverVacation>>(
      `/user/${driverId}/driver_vacation`,
    );
    return response.data;
  },
};
